import { useRouter } from 'next/compat/router'

import { isNewTabClick, openInNewTab } from '@/utils/newTab'

import { getRuleHref } from '../utils/ruleRoutes'

type OpenRuleEvent = Parameters<typeof isNewTabClick>[0]

interface UseOpenRuleResultIProps {
  openRule: (id: string, isV2: boolean, event?: OpenRuleEvent) => void
}

/**
 * Opens a rule's detail page from a rules table row: in a new tab for
 * Cmd/Ctrl + click or middle-click, otherwise in the current tab. Shared by
 * the legacy and dark rules tables so both route rules the same way.
 */
export const useOpenRule = (): UseOpenRuleResultIProps => {
  const { push } = useRouter()

  const openRule = (id: string, isV2: boolean, event?: OpenRuleEvent) => {
    const href = getRuleHref(id, isV2)
    if (event && isNewTabClick(event)) {
      openInNewTab(href)
      return
    }
    push(href)
  }

  return { openRule }
}
